import { useLang } from '../context/LangContext'
import { ja } from './langs/ja'
import { en } from './langs/en'

export const useGetTranslatedValue = () => {
  const { lang } = useLang()
  return (key) => {
    const src = lang === 'en' ? { ...en } : { ...ja }
    return src[key] ?? ''
  }
}
